/* tslint:disable */
/* eslint-disable */
/**
 * Datixo API
 * API endpoints for communication with Datixo.
 *
 * The version of the OpenAPI document: v1.0.0
 * Contact: api@datixo.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { MultiCurrencyMoney } from './MultiCurrencyMoney';
import {
    MultiCurrencyMoneyFromJSON,
    MultiCurrencyMoneyFromJSONTyped,
    MultiCurrencyMoneyToJSON,
    MultiCurrencyMoneyToJSONTyped,
} from './MultiCurrencyMoney';

/**
 * 
 * @export
 * @interface DateRangeOrdersGranular
 */
export interface DateRangeOrdersGranular {
    /**
     * 
     * @type {number}
     * @memberof DateRangeOrdersGranular
     */
    currentOrdersTotal?: number;
    /**
     * 
     * @type {MultiCurrencyMoney}
     * @memberof DateRangeOrdersGranular
     */
    currentPriceTotal?: MultiCurrencyMoney;
    /**
     * 
     * @type {{ [key: string]: number; }}
     * @memberof DateRangeOrdersGranular
     */
    currentOrdersGranular?: { [key: string]: number; };
    /**
     * 
     * @type {{ [key: string]: MultiCurrencyMoney; }}
     * @memberof DateRangeOrdersGranular
     */
    currentPriceGranular?: { [key: string]: MultiCurrencyMoney; };
    /**
     * 
     * @type {number}
     * @memberof DateRangeOrdersGranular
     */
    previousOrdersTotal?: number;
    /**
     * 
     * @type {MultiCurrencyMoney}
     * @memberof DateRangeOrdersGranular
     */
    previousPriceTotal?: MultiCurrencyMoney;
    /**
     * 
     * @type {{ [key: string]: number; }}
     * @memberof DateRangeOrdersGranular
     */
    previousOrdersGranular?: { [key: string]: number; };
    /**
     * 
     * @type {{ [key: string]: MultiCurrencyMoney; }}
     * @memberof DateRangeOrdersGranular
     */
    previousPriceGranular?: { [key: string]: MultiCurrencyMoney; };
}

/**
 * Check if a given object implements the DateRangeOrdersGranular interface.
 */
export function instanceOfDateRangeOrdersGranular(value: object): value is DateRangeOrdersGranular {
    return true;
}

export function DateRangeOrdersGranularFromJSON(json: any): DateRangeOrdersGranular {
    return DateRangeOrdersGranularFromJSONTyped(json, false);
}

export function DateRangeOrdersGranularFromJSONTyped(json: any, ignoreDiscriminator: boolean): DateRangeOrdersGranular {
    if (json == null) {
        return json;
    }
    return {
        
        'currentOrdersTotal': json['currentOrdersTotal'] == null ? undefined : json['currentOrdersTotal'],
        'currentPriceTotal': json['currentPriceTotal'] == null ? undefined : MultiCurrencyMoneyFromJSON(json['currentPriceTotal']),
        'currentOrdersGranular': json['currentOrdersGranular'] == null ? undefined : json['currentOrdersGranular'],
        'currentPriceGranular': json['currentPriceGranular'] == null ? undefined : (mapValues(json['currentPriceGranular'], MultiCurrencyMoneyFromJSON)),
        'previousOrdersTotal': json['previousOrdersTotal'] == null ? undefined : json['previousOrdersTotal'],
        'previousPriceTotal': json['previousPriceTotal'] == null ? undefined : MultiCurrencyMoneyFromJSON(json['previousPriceTotal']),
        'previousOrdersGranular': json['previousOrdersGranular'] == null ? undefined : json['previousOrdersGranular'],
        'previousPriceGranular': json['previousPriceGranular'] == null ? undefined : (mapValues(json['previousPriceGranular'], MultiCurrencyMoneyFromJSON)),
    };
}

export function DateRangeOrdersGranularToJSON(json: any): DateRangeOrdersGranular {
    return DateRangeOrdersGranularToJSONTyped(json, false);
}

export function DateRangeOrdersGranularToJSONTyped(value?: DateRangeOrdersGranular | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'currentOrdersTotal': value['currentOrdersTotal'],
        'currentPriceTotal': MultiCurrencyMoneyToJSON(value['currentPriceTotal']),
        'currentOrdersGranular': value['currentOrdersGranular'],
        'currentPriceGranular': value['currentPriceGranular'] == null ? undefined : (mapValues(value['currentPriceGranular'], MultiCurrencyMoneyToJSON)),
        'previousOrdersTotal': value['previousOrdersTotal'],
        'previousPriceTotal': MultiCurrencyMoneyToJSON(value['previousPriceTotal']),
        'previousOrdersGranular': value['previousOrdersGranular'],
        'previousPriceGranular': value['previousPriceGranular'] == null ? undefined : (mapValues(value['previousPriceGranular'], MultiCurrencyMoneyToJSON)),
    };
}

